import { adapter, Filter } from '../index';
import { A9DecoratorsCommon } from './A9DecoratorsCommon';

export interface IA9Filter {
    name?: string;
}

export function A9Filter(object?: IA9Filter | string) {
    return function (filter: any) {
        const injectorParams = A9DecoratorsCommon.parseConstructorParams(filter);

        const parent = <typeof Filter>filter;

        class ChildFilter extends parent {
            public static filter: IA9Filter;
            public static injectorParams: string[] = [];

            public static get $name() {
                return (typeof object === 'string' && object) || (filter.hasOwnProperty('$name') && filter.$name) || filter.name;
            }

            public static get $inject() {
                return ChildFilter.injectorParams;
            }
        }

        ChildFilter.filter = filter;
        ChildFilter.injectorParams = injectorParams;

        adapter.linkFilter(<typeof filter>ChildFilter);
        return <typeof filter>ChildFilter;
    };
}
